<template>
  <div>
    <show-bines-tef ref="ShowBinesTef"/>
  </div>
</template>
<script>
export default {
  components: {
    ShowBinesTef: () => import('./ShowBinesTef.vue')
  },
}
</script>
